import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  OtherIncomeCreateInput,
  OtherIncomeModel,
  OtherIncomeUpdateInput,
  OtherIncomeVoidInput,
} from './model';

export function useCreateOtherIncome(
  options?: UseMutationOptions<
    ApiResult<OtherIncomeModel>,
    ApiError,
    OtherIncomeCreateInput
  >,
): UseMutationResult<
  ApiResult<OtherIncomeModel>,
  ApiError,
  OtherIncomeCreateInput
> {
  return useMutation<
    ApiResult<OtherIncomeModel>,
    ApiError,
    OtherIncomeCreateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'other-incomes',
      method: 'POST',
      classType: OtherIncomeModel,
      body,
    });
  }, options);
}

export function useUpdateOtherIncome(
  options?: UseMutationOptions<
    ApiResult<OtherIncomeModel>,
    ApiError,
    OtherIncomeUpdateInput
  >,
): UseMutationResult<
  ApiResult<OtherIncomeModel>,
  ApiError,
  OtherIncomeUpdateInput
> {
  return useMutation<
    ApiResult<OtherIncomeModel>,
    ApiError,
    OtherIncomeUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `other-incomes/${body.otherIncomeRefId}`,
      method: 'PUT',
      classType: OtherIncomeModel,
      body: body.body,
    });
  }, options);
}

export function useVoidOtherIncome(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    OtherIncomeVoidInput
  >,
): UseMutationResult<{ message: string }, ApiError, OtherIncomeVoidInput> {
  return useMutation<{ message: string }, ApiError, OtherIncomeVoidInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `other-incomes/${body.otherIncomeRefId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
